import { useHistory } from 'react-router-dom';
import { commonModules } from '.';

const useVolSelfID = () => {
  const { useRoutePath } = commonModules;
  const { getBasePath } = useRoutePath(),
        VolSelfIdDisUpd = getBasePath('gwVolSelfIdDisUpd'),
        history = useHistory(),
        routeToVolSelfId = () => {
          history.push(VolSelfIdDisUpd);
        };

  return {
    routeToVolSelfId,
  };
};

export default useVolSelfID;